import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {HandlerOf, Renderer} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {CheckBox} from '../../../../libs/shared/ui/src/components/booleanInputs/checkBox';
import {
  virtualTableHeaderRowHeight,
  VirtualTableMultiSelectStatesEnum,
  virtualTableRowCheckboxWrapperWidth,
} from './helpers/tableHelpers';

/*
 * Props.
 */

interface TableMultiSelectHeaderRowProps {
  multiSelectStatus?: VirtualTableMultiSelectStatesEnum;
  renderTotalItemsLabel: Renderer;
  onMultiSelectChange: HandlerOf<boolean>;
  isDisabled?: boolean;
}

/*
 * Style.
 */

const StyledMultiSelectRowContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  position: sticky;
  background: ${(p) => p.theme.foreground};
  top: 0;
  z-index: 1;
  min-height: ${virtualTableHeaderRowHeight}px;
  margin-bottom: 8px;
`;

const StyledMultiSelectRowActionsContainerDiv = styled.div`
  display: flex;
  flex-flow: row;
  flex: 1;
`;

const StyledMultiSelectRowActionsDiv = styled.div`
  position: sticky;
  left: ${virtualTableRowCheckboxWrapperWidth}px;
  padding: 5px 0 0 12px;
  height: 40px;
`;

const StyledMultiSelectRowTotalContainerDiv = styled.div`
  position: sticky;
  right: 0;
  top: 14px;
  height: 16px;
  color: ${(p) => p.theme.greys.shade70};
`;

const StyledCheckboxWrapper = styled.div`
  position: sticky;
  display: flex;
  left: 0;
  flex: 0 0 ${virtualTableRowCheckboxWrapperWidth}px;
  background: ${(p) => p.theme.foreground};
`;

const StyledCheckBox = styled(CheckBox)`
  margin-left: 10px;
`;

/*
 * Component.
 */

export const TableMultiSelectHeaderRow: FC<PropsWithChildren<TableMultiSelectHeaderRowProps>> = (props) => {
  const {children, multiSelectStatus, renderTotalItemsLabel, onMultiSelectChange, isDisabled} = props;

  return (
    <StyledMultiSelectRowContainerDiv>
      <StyledMultiSelectRowActionsContainerDiv>
        <StyledCheckboxWrapper>
          <StyledCheckBox
            isDisabled={isDisabled}
            isChecked={multiSelectStatus === VirtualTableMultiSelectStatesEnum.CHECKED}
            isIndeterminate={multiSelectStatus === VirtualTableMultiSelectStatesEnum.INDETERMINATE}
            onChange={onMultiSelectChange}
          />
        </StyledCheckboxWrapper>
        <StyledMultiSelectRowActionsDiv>{children}</StyledMultiSelectRowActionsDiv>
      </StyledMultiSelectRowActionsContainerDiv>
      <StyledMultiSelectRowTotalContainerDiv>{renderTotalItemsLabel()}</StyledMultiSelectRowTotalContainerDiv>
    </StyledMultiSelectRowContainerDiv>
  );
};
